import $ from "jquery";

function initArticle(item, config, $article, module) {
	const $body = $article.children(".article-body");
	
	const $images = $body.children('.images');
	$images.children(".echoed-data").each((i, elm) => {
		$(elm).attr("data-index", i);
	});
	
	const $exp = $body.children('.echoed-data[data-key="exp"]');
	$exp.find(".ql-video").wrap(
		$("<div/>").addClass("video-container")
	);
}

export { initArticle };
